import React, { useState } from "react"
import { graphql } from 'gatsby';
import SEO from '../components/SEO/SEOPage';
import Layout from '../components/shared/layout';
import { wrapper, color, breakpoints } from '../utils/style';
import styled from '@emotion/styled';
import ButtonLink from '../components/shared/ButtonLink';
import Img from "gatsby-image"

const Wrapper = styled('div')`
  ${wrapper}
  .info-wrapper {
    margin: 30px auto;
    padding: 60px 30px;
    background: ${color.transparentWhite1};
    border-radius: 16px;
    text-align: center;
    h1 {
      margin:0 0 30px;
    }
    p {
      margin: 30px 0;
    }
  }
  .img-wrap {
    width: 100%;
    max-width: 150px;
    margin: 20px auto;
  }
  @media (max-width: ${breakpoints.sm}) {
    .info-wrapper {
      padding: 30px 15px;
    }
  }
  
`;

const NotFoundPage = ({ data }) => {
  const [registerType, setRegisterType]  = useState((typeof window !== 'undefined' && localStorage != null && localStorage.money_type) ? localStorage.money_type : "")

  if(registerType === "real_money") {
    setTimeout(() => {
      localStorage.clear();
    }, 3000);
  }

  return (
  <Layout>
    <SEO title='ลงทะเบียนเสร็จสมบูรณ์!' />
    <Wrapper>
      <div className={"info-wrapper"}>
        {registerType === "real_money" ?
          <>
            <h1>ลงทะเบียนเสร็จสมบูรณ์!</h1>
            <p>ผู้เล่นคาสิโน กรุณาเพิ่ม LNWASIAGROUP เป็นเพื่อน เพื่อสร้างบัญชีของคุณให้สมบูรณ์</p>
            <p>ผู้เล่นสล็อตฟรี 15 ครั้ง กรุณาเช็คอีเมลของคุณ เพื่อทำการเปิดใช้งานบัญชี</p>
            {data.code.childImageSharp.fluid &&
              <div className="img-wrap">
            <Img alt="QR-code" fluid={data.code.childImageSharp.fluid} fadeIn={false} loading='eager' />
              </div>
            }
            <ButtonLink
              to={process.env.LINE_ID_EXT}
              text={process.env.LINE_ID_TEXT}
              external={true}
              className="button green-button"
              iconName="line"
              iconSize={20}
              ariaText="Line"
              iconLeft={true}
            />
          </> :
          <>
            <h1>ลงทะเบียนเสร็จสมบูรณ์!</h1>
            <p>บันทึกรายละเอียดบัญชีเรียบร้อยแล้ว กรุณาตรวจสอบอีเมลของท่านเพื่อเปิดการใช้งาน Free Spin</p>
          </>
        }
      </div>
    </Wrapper>
  </Layout>
  )
};

export default NotFoundPage;

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    missing: file(relativePath: { eq: "404.png" }) {
      childImageSharp {
          fluid(maxWidth: 480) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    code: file(relativePath: { eq: "QR-code.png" }) {
      childImageSharp {
        fluid(maxWidth: 150) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }   
  }
`;
